/* import __COLOCATED_TEMPLATE__ from './mount-point.hbs'; */
// copied from https://github.com/squareup/dashboard/blob/rcohen/system-js-spike/frontend/%40dashboard/core-setup/addon/components/micro-frontend/mount-point.ts#L21-L42
import 'systemjs';
import Component from '@glimmer/component';
import { getBrowserTimeZone } from '@dashboard/junk-drawer/utils/time';
import { getUrlParams } from '@square/dashboard-utilities/utils/window';
export default class MountPoint extends Component {
  get bundleName() {
    return 'main';
  }
  get manifestPath() {
    let manifestPath = '/balance-ui/api/dashboard-spa-manifest';
    const params = getUrlParams();
    const previewBuild = params.get('balance-ui-branch');
    manifestPath = previewBuild ? `${manifestPath}?previewBuild=${previewBuild}` : manifestPath;
    return manifestPath;
  }
  get customProps() {
    return {
      containerName: this.args.containerName,
      linkBankAccount: this.args.linkBankAccount,
      pageName: this.args.pageName,
      timezone: getBrowserTimeZone(),
      unitToken: this.args.unitToken
    };
  }
}